import { useContext } from "react"
import { FeedContext } from "./FeedContext"
import type { FeedContextValue } from "./FeedContextValue"

export function useFeedContext(): FeedContextValue {
  return useContext(FeedContext)
}
